const SET_PERMISSIONS = 'realhub/settings/SET_PERMISSIONS'

// Initial State
const initialState = {
  permissions: {},
}

// Actions
export function hydratePermissions(permissions = {}){
  return {
    type: SET_PERMISSIONS,
    permissions,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case SET_PERMISSIONS:
      return Object.assign({}, state, {
        permissions: action.permissions,
      })
    default:
      return state
  }
}
